<section class="banner-section aiContentDetector">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>감지기 (AI Content Detector)</h1></div>
                    <p>ChatGPT, GPT-4, Bard, Bing Chat과 같은 모든 LLM에서 AI가 생성한 텍스트를 즉시 감지해 콘텐츠 무결성을 보호해보세요.</p>
                    <p>트링카 AI 콘텐츠 감지기와 우리의 첨단 시스템을 사용하면 AI가 생성한 콘텐츠를 정확하게 식별할 것입니다. </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h3>AI가 생성한 콘텐츠 감지</h3>
                        <div class="sessionsLeftInfo">
                            <ul>
                                <li *ngIf="usersCurrentAvailableSessionCount > -1">
                                    <span [ngClass]="usersCurrentAvailableSessionCount === 0 ? 'red-txt': ''">오늘 {{usersCurrentAvailableSessionCount}}/10 세션 남아 있음</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="left-side">
                            <div class="form-group" [ngClass]="[showWordLimitErr && wordLimitErrMsg.includes('500') ? 'show-max-overlay' : '']">
                                <div class="editor-wrapper scollBarAI" [ngClass]="[showErrorModal ? 'hide-all-content' : showLoadingState ? 'blur-content' : aiContentScore > 0 ? 'error-txt' : '']">
                                    <span *ngIf="inputWordCount" class="cross-icon-times" (click)="clearEditors();"></span>
                                    <div [contentEditable]="!showLoadingState && aiContentScore === 0 && humanContentScore === 0 && !showErrorModal" id="inputEditor"
                                        placeholder="영문 텍스트를 입력 또는 붙여넣기 해주세요.(최소 100 단어)" class="editor" (input)="onInputEditorChange($event.target.innerText)">
                                    </div>
                                    <div class="error-container" *ngIf="showErrorModal">
                                        <div class="error-txt-container">
                                            <span class="danger-icon"></span>
                                            <span class="error-txt">An error occurred, please try again</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="limit-snackbar" [ngClass]="wordLimitErrHeading.includes('100') ? 'min-limit-snackbar' : 'max-limit-snackbar'" *ngIf="showWordLimitErr">
                                    <h3>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.4645 14.3459L13.248 4.95619C12.5471 3.69282 11.5771 3 10.5094 3C9.44161 3 8.47166 3.69282 7.77069 4.95619L2.55419 14.3459C1.89397 15.5441 1.82062 16.6933 2.35042 17.5981C2.88022 18.5028 3.92352 19 5.29285 19H15.7259C17.0952 19 18.1385 18.5028 18.6683 17.5981C19.1981 16.6933 19.1247 15.5359 18.4645 14.3459ZM9.89805 8.70555C9.89805 8.37137 10.1752 8.09424 10.5094 8.09424C10.8435 8.09424 11.1207 8.37137 11.1207 8.70555V12.7809C11.1207 13.1151 10.8435 13.3923 10.5094 13.3923C10.1752 13.3923 9.89805 13.1151 9.89805 12.7809V8.70555ZM11.0881 15.8049C11.0473 15.8375 11.0066 15.8701 10.9658 15.9027C10.9169 15.9353 10.868 15.9598 10.8191 15.9761C10.7702 16.0005 10.7213 16.0168 10.6642 16.025C10.6153 16.0331 10.5583 16.0413 10.5094 16.0413C10.4605 16.0413 10.4034 16.0331 10.3463 16.025C10.2974 16.0168 10.2485 16.0005 10.1996 15.9761C10.1507 15.9598 10.1018 15.9353 10.0529 15.9027C10.0122 15.8701 9.97141 15.8375 9.93065 15.8049C9.78394 15.65 9.69428 15.4381 9.69428 15.2262C9.69428 15.0143 9.78394 14.8023 9.93065 14.6475C9.97141 14.6149 10.0122 14.5823 10.0529 14.5497C10.1018 14.5171 10.1507 14.4926 10.1996 14.4763C10.2485 14.4519 10.2974 14.4356 10.3463 14.4274C10.4523 14.403 10.5664 14.403 10.6642 14.4274C10.7213 14.4356 10.7702 14.4519 10.8191 14.4763C10.868 14.4926 10.9169 14.5171 10.9658 14.5497C11.0066 14.5823 11.0473 14.6149 11.0881 14.6475C11.2348 14.8023 11.3244 15.0143 11.3244 15.2262C11.3244 15.4381 11.2348 15.65 11.0881 15.8049Z" fill="#FFBD4A"/>
                                        </svg>
                                        {{wordLimitErrHeading}}
                                    </h3>
                                    <p [innerHTML]="wordLimitErrMsg" *ngIf="wordLimitErrMsg"></p>
                                    <span class="limit-modal-close" mat-icon-button aria-label="close" (click)="hideLimitError()">
                                        <mat-icon>close</mat-icon>
                                    </span>
                                </div>
                            </div>
                            
                        </div>

                    </div>
                    <div class="card-footer" [ngClass]="inputWordCount > 0 ? '' : 'hide-box-shadow'">
                        <div class="word-count-outer" *ngIf="!showLoadingState && !showErrorModal">
                            <div class="counter">
                                <span class="count" [ngClass]="inputWordCount > 500 ? 'red-txt': inputWordCount > 0 ? 'black-txt' : ''">{{ inputWordCount }}/500 단어</span>
                            </div>
                        </div>
                        <div class="button-wrap">
                            <button *ngIf="!aiContentScore && !humanContentScore" (click)="sendTextForAIDetection()" [ngClass]="[showLoadingState ? 'loaderStateBtn' : '']" [disabled]="inputWordCount === 0 || isSubmitBtnDisabled || showLoadingState">
                                <span *ngIf="showLoadingState" class="animated-loader"></span>
                                <span>{{showLoadingState ? '점검' : showErrorModal ? 'Reload' : '확인'}}</span>
                            </button>
                            <div class="ai-generated-txt-btn" *ngIf="aiContentScore">
                                AI Generated Text ({{aiContentScore.toFixed(2)}}%)
                            </div>
                            <div class="human-generated-txt-btn" *ngIf="humanContentScore">
                                인간 생성 텍스트 ({{humanContentScore.toFixed(2)}}%)
                            </div>
                            <span class="like-dislike-container" *ngIf="humanContentScore || aiContentScore">
                                <span class="feedback-like-icon" (click)="openFeedbackModal(true)"></span>
                                <span class="feedback-dislike-icon" (click)="openFeedbackModal(false)"></span>
                            </span>
                        </div>
                    </div>
                    <div class="ftContent" *ngIf="humanContentScore">
                        <div class="human-generated-txt-content">
                            <h6>점수 설명:</h6>
                            <span class="information-icon-green">
                                <span class="information-icon-content-outer">
                                    <span class="information-icon-content-score">
                                        이 점수는 스캔한 콘텐츠가 ChatGPT/GPT-X와 같은 LLM에 의해 생성된 것임을 예측하는 모델의 
                                        신뢰도를 반영합니다. 이 점수는 텍스트의 {{humanContentScore.toFixed(2)}}%를 인간이 생성한 것임을 나타냅니다. 이 점수는 각 문장 내에서 AI가
                                        생성한 콘텐츠를 식별하는 문장 수준 분석을 통해 계산됐습니다.
                                        <!-- The score reflects our model's confidence in predicting that the content scanned was produced by any of the LLMs such as ChatGPT/GPT-X. The score indicates that {{humanContentScore.toFixed(2)}}% of your text is Human generated. This score was computed through sentence-level analysis, where we discerned AI-generated content within each sentence. -->
                                        <!-- This indicates that {{humanContentScore.toFixed(2)}}% of your text is Human generated. The result has been calculated by analyzing all sentences and determining the AI content composition in each.  -->
                                    </span>
                                    <span class="information-icon-content-constant">
                                        당사의 시스템은 영어로 작성된 AI 생성 콘텐츠를
                                        예측하는 데 탁월하도록 맞춤화돼 있습니다. 다른 언어에 대한 정확도 수준은 이 능숙도와 같지 않을 수 있다는 
                                        점에 주목할 가치가 있습니다.
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="ftContent" *ngIf="aiContentScore">
                        <div class="human-generated-txt-content">
                            <h6>점수 설명:</h6>
                            <span class="information-icon-red">
                                <span class="information-icon-content-outer">
                                    <span class="information-icon-content-score">
                                        이 점수는 스캔한 콘텐츠가 ChatGPT/GPT-X와 같은 LLM에 의해 생성된 것임을 예측하는 모델의 
                                        신뢰도를 반영합니다. 이 점수는 텍스트의 {{aiContentScore.toFixed(2)}}%를 인간이 생성한 것임을 나타냅니다. 이 점수는 각 문장 내에서 AI가
                                        생성한 콘텐츠를 식별하는 문장 수준 분석을 통해 계산됐습니다.
                                        <!-- The score reflects our model's confidence in predicting that the content scanned was produced by any of the LLMs such as ChatGPT/GPT-X. The score indicates that {{aiContentScore.toFixed(2)}}% of your text is AI generated. This score was computed through sentence-level analysis, where we discerned AI-generated content within each sentence. -->
                                        <!-- This indicates that {{aiContentScore.toFixed(2)}}% of your text is AI generated. The result has been calculated by analyzing all sentences and determining the AI content composition in each.  -->
                                    </span>
                                    <span class="information-icon-content-constant">
                                        당사의 시스템은 영어로 작성된 AI 생성 콘텐츠를
                                        예측하는 데 탁월하도록 맞춤화돼 있습니다. 다른 언어에 대한 정확도 수준은 이 능숙도와 같지 않을 수 있다는 
                                        점에 주목할 가치가 있습니다.                                    
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="disclaimerBox">
                    <a href="#howtoUseModal" data-toggle="modal" data-target="#howtoUseModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M11.6849 8.99945C11.6849 10.4845 10.4849 11.6845 8.99994 11.6845C7.51494 11.6845 6.31494 10.4845 6.31494 8.99945C6.31494 7.51445 7.51494 6.31445 8.99994 6.31445C10.4849 6.31445 11.6849 7.51445 11.6849 8.99945Z" stroke="#7A28A0" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.00013 15.2025C11.6476 15.2025 14.1151 13.6425 15.8326 10.9425C16.5076 9.88504 16.5076 8.10754 15.8326 7.05004C14.1151 4.35004 11.6476 2.79004 9.00013 2.79004C6.35263 2.79004 3.88513 4.35004 2.16763 7.05004C1.49263 8.10754 1.49263 9.88504 2.16763 10.9425C3.88513 13.6425 6.35263 15.2025 9.00013 15.2025Z" stroke="#7A28A0" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> 사용 단계
                    </a>
                    <a href="#disclaimerModal" data-toggle="modal" data-target="#disclaimerModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M9 0.937499C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625C4.5525 17.0625 0.9375 13.4475 0.937501 9C0.937501 4.5525 4.5525 0.937499 9 0.937499ZM9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375Z" fill="#7A28A0"/>
                            <path d="M9 7.6875C9.3075 7.6875 9.5625 7.9425 9.5625 8.25L9.5625 12C9.5625 12.3075 9.3075 12.5625 9 12.5625C8.6925 12.5625 8.4375 12.3075 8.4375 12L8.4375 8.25C8.4375 7.9425 8.6925 7.6875 9 7.6875Z" fill="#7A28A0"/>
                            <path d="M9 5.24984C9.0975 5.24984 9.195 5.27234 9.285 5.30984C9.375 5.34734 9.4575 5.39984 9.5325 5.46734C9.6 5.54234 9.6525 5.61734 9.69 5.71484C9.7275 5.80484 9.75 5.90234 9.75 5.99984C9.75 6.09734 9.7275 6.19484 9.69 6.28484C9.6525 6.37484 9.6 6.45734 9.5325 6.53234C9.4575 6.59984 9.375 6.65234 9.285 6.68984C9.105 6.76484 8.895 6.76484 8.715 6.68984C8.625 6.65234 8.5425 6.59984 8.4675 6.53234C8.4 6.45734 8.3475 6.37484 8.31 6.28484C8.2725 6.19484 8.25 6.09734 8.25 5.99984C8.25 5.90234 8.2725 5.80484 8.31 5.71484C8.3475 5.61734 8.4 5.54234 8.4675 5.46734C8.5425 5.39984 8.625 5.34734 8.715 5.30984C8.805 5.27234 8.9025 5.24984 9 5.24984Z" fill="#7A28A0"/>
                        </svg> 면책 조항 표시
                    </a>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<!-- The howtoUseModal -->
<div class="modal aiContentModal" id="howtoUseModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-radius16">
        <div class="modal-body howto-use">
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M21.825 7.82463C22.2806 7.36902 22.2806 6.63033 21.825 6.17472C21.3694 5.7191 20.6307 5.7191 20.1751 6.17472L14 12.3498L7.825 6.17472C7.36939 5.7191 6.63069 5.7191 6.17508 6.17472C5.71947 6.63033 5.71947 7.36902 6.17508 7.82463L12.3501 13.9997L6.17508 20.1747C5.71947 20.6303 5.71947 21.369 6.17508 21.8246C6.63069 22.2802 7.36939 22.2802 7.825 21.8246L14 15.6496L20.1751 21.8246C20.6307 22.2802 21.3694 22.2802 21.825 21.8246C22.2806 21.369 22.2806 20.6303 21.825 20.1747L15.65 13.9997L21.825 7.82463Z" fill="#414E62"/>
                </svg>
            </button>
            <h4>사용 단계</h4>
            <div class="row match-box">
                <div class="col-lg-4 col-md-12 dflex no-gutter">
                    <div class="useCard c-card">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M4.61763 16.2666C4.1093 16.2666 3.6343 16.0916 3.29263 15.7666C2.8593 15.3583 2.65097 14.7416 2.72597 14.075L3.0343 11.375C3.09263 10.8666 3.40097 10.1916 3.7593 9.82496L10.601 2.58329C12.3093 0.774959 14.0926 0.72496 15.901 2.43329C17.7093 4.14163 17.7593 5.92496 16.051 7.73329L9.2093 14.975C8.8593 15.35 8.2093 15.7 7.70096 15.7833L5.01763 16.2416C4.87597 16.25 4.75097 16.2666 4.61763 16.2666ZM13.276 2.42496C12.6343 2.42496 12.076 2.82496 11.5093 3.42496L4.66763 10.675C4.50097 10.85 4.3093 11.2666 4.27597 11.5083L3.96763 14.2083C3.9343 14.4833 4.00097 14.7083 4.15097 14.85C4.30097 14.9916 4.52597 15.0416 4.80097 15L7.4843 14.5416C7.72597 14.5 8.12597 14.2833 8.29263 14.1083L15.1343 6.86663C16.1676 5.76663 16.5426 4.74996 15.0343 3.33329C14.3676 2.69163 13.7926 2.42496 13.276 2.42496Z" fill="#7A28A0"/>
                                <path d="M14.4497 9.12504C14.433 9.12504 14.408 9.12504 14.3914 9.12504C11.7914 8.8667 9.69971 6.8917 9.29971 4.30837C9.24971 3.9667 9.48305 3.65004 9.82471 3.5917C10.1664 3.5417 10.483 3.77504 10.5414 4.1167C10.858 6.13337 12.4914 7.68337 14.5247 7.88337C14.8664 7.9167 15.1164 8.22504 15.083 8.5667C15.0414 8.88337 14.7664 9.12504 14.4497 9.12504Z" fill="#7A28A0"/>
                                <path d="M17.5 18.958H2.5C2.15833 18.958 1.875 18.6747 1.875 18.333C1.875 17.9913 2.15833 17.708 2.5 17.708H17.5C17.8417 17.708 18.125 17.9913 18.125 18.333C18.125 18.6747 17.8417 18.958 17.5 18.958Z" fill="#7A28A0"/>
                            </svg>
                        </span>
                        <small>1단계</small>
                        <h3>텍스트 붙여넣기/입력하기</h3>
                        <p>빈 공간에 텍스트를 입력 또는 붙여넣기해 주세요. 해당 툴은 영어에 최적화되어 있습니다. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 dflex no-gutter">
                    <div class="useCard middleCard c-card">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <path d="M13.7504 11.8711H7.33376C6.95792 11.8711 6.64626 11.5594 6.64626 11.1836C6.64626 10.8078 6.95792 10.4961 7.33376 10.4961H13.7504C14.1263 10.4961 14.4379 10.8078 14.4379 11.1836C14.4379 11.5594 14.1263 11.8711 13.7504 11.8711Z" fill="#7A28A0"/>
                                <path d="M11.3488 15.5371H7.33376C6.95792 15.5371 6.64626 15.2254 6.64626 14.8496C6.64626 14.4738 6.95792 14.1621 7.33376 14.1621H11.3488C11.7246 14.1621 12.0363 14.4738 12.0363 14.8496C12.0363 15.2254 11.7246 15.5371 11.3488 15.5371Z" fill="#7A28A0"/>
                                <path d="M12.8338 6.18717H9.16709C8.28709 6.18717 6.64626 6.18717 6.64626 3.66634C6.64626 1.14551 8.28709 1.14551 9.16709 1.14551H12.8338C13.7138 1.14551 15.3546 1.14551 15.3546 3.66634C15.3546 4.54634 15.3546 6.18717 12.8338 6.18717ZM9.16709 2.52051C8.25959 2.52051 8.02126 2.52051 8.02126 3.66634C8.02126 4.81217 8.25959 4.81217 9.16709 4.81217H12.8338C13.9796 4.81217 13.9796 4.57384 13.9796 3.66634C13.9796 2.52051 13.7413 2.52051 12.8338 2.52051H9.16709Z" fill="#7A28A0"/>
                                <path d="M13.75 20.8536H8.25C3.09833 20.8536 2.0625 18.4886 2.0625 14.6661V9.16608C2.0625 4.98608 3.575 3.19858 7.29667 3.00608C7.66333 2.98774 8.0025 3.27191 8.02083 3.65691C8.03917 4.04191 7.74583 4.35358 7.37 4.37191C4.76667 4.51858 3.4375 5.29774 3.4375 9.16608V14.6661C3.4375 18.0577 4.10667 19.4786 8.25 19.4786H13.75C17.8933 19.4786 18.5625 18.0577 18.5625 14.6661V9.16608C18.5625 5.29774 17.2333 4.51858 14.63 4.37191C14.2542 4.35358 13.9608 4.02358 13.9792 3.64774C13.9975 3.27191 14.3275 2.97858 14.7033 2.99691C18.425 3.19858 19.9375 4.98607 19.9375 9.15691V14.6569C19.9375 18.4886 18.9017 20.8536 13.75 20.8536Z" fill="#7A28A0"/>
                            </svg>
                        </span>
                        <small>2단계</small>
                        <h3>클릭 '확인'</h3>
                        <p>'확인' 버튼을 클릭하면 <br/>
                            AI 콘텐츠 감지기(AI Content Detector)<br/>
                            가 시작합니다. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 dflex no-gutter">
                    <div class="useCard c-card">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                <path d="M13.9567 20.8538H7.83333C4.4875 20.8538 2.5625 18.9288 2.5625 15.583V7.79134C2.5625 4.44551 4.4875 2.52051 7.83333 2.52051H15.1667C18.5125 2.52051 20.4375 4.44551 20.4375 7.79134V12.4938C20.4375 12.7597 20.2817 12.998 20.0525 13.1172C19.8142 13.2272 19.53 13.1996 19.3283 13.0346C17.88 11.8796 15.6525 11.8797 14.2042 13.0622C13.2142 13.8413 12.655 15.0055 12.655 16.2797C12.655 17.0314 12.8567 17.7647 13.2508 18.3972C13.5533 18.8922 13.9292 19.3047 14.3692 19.6164C14.6075 19.7905 14.7175 20.1022 14.6258 20.3863C14.5158 20.6613 14.2592 20.8538 13.9567 20.8538ZM7.83333 3.89551C5.21167 3.89551 3.9375 5.16967 3.9375 7.79134V15.583C3.9375 18.2047 5.21167 19.4788 7.83333 19.4788H12.3158C12.2242 19.3597 12.1417 19.2314 12.0683 19.103C11.5458 18.2597 11.2708 17.2788 11.2708 16.2705C11.2708 14.5747 12.0225 13.0163 13.3425 11.9805C14.91 10.7063 17.2292 10.4313 19.0625 11.2747V7.79134C19.0625 5.16967 17.7883 3.89551 15.1667 3.89551H7.83333Z" fill="#7A28A0"/>
                                <path d="M16.7715 21.7713C15.5982 21.7713 14.489 21.4046 13.554 20.7263C12.9673 20.3046 12.4631 19.7547 12.069 19.1038C11.5465 18.2605 11.2715 17.2796 11.2715 16.2713C11.2715 14.5755 12.0232 13.0171 13.3432 11.9813C15.2498 10.4321 18.2565 10.4229 20.1815 11.9538C21.5107 12.9988 22.2715 14.5755 22.2715 16.2713C22.2715 17.2796 21.9965 18.2605 21.474 19.1038C21.1807 19.608 20.8048 20.048 20.374 20.4055C19.3931 21.2855 18.1098 21.7713 16.7715 21.7713ZM16.7715 12.1463C15.8365 12.1463 14.9198 12.4671 14.1957 13.0538C13.2057 13.833 12.6465 14.9971 12.6465 16.2713C12.6465 17.023 12.8481 17.7563 13.2423 18.3888C13.5448 18.8838 13.9206 19.2963 14.3606 19.608C15.0665 20.1213 15.9007 20.3963 16.7715 20.3963C17.789 20.3963 18.724 20.0388 19.4757 19.3696C19.8057 19.0946 20.0715 18.7738 20.2915 18.398C20.6856 17.7563 20.8965 17.023 20.8965 16.2713C20.8965 14.9971 20.3282 13.8238 19.329 13.0354C18.5957 12.4488 17.7157 12.1463 16.7715 12.1463Z" fill="#7A28A0"/>
                                <path d="M16.7702 19.2503C16.3943 19.2503 16.0827 18.9387 16.0827 18.5628C16.0827 17.6828 15.3585 16.9587 14.4785 16.9587C14.1027 16.9587 13.791 16.647 13.791 16.2712C13.791 15.8953 14.1027 15.5837 14.4785 15.5837C15.3585 15.5837 16.0827 14.8595 16.0827 13.9795C16.0827 13.6037 16.3943 13.292 16.7702 13.292C17.146 13.292 17.4577 13.6037 17.4577 13.9795C17.4577 14.8595 18.1818 15.5837 19.0618 15.5837C19.4377 15.5837 19.7493 15.8953 19.7493 16.2712C19.7493 16.647 19.4377 16.9587 19.0618 16.9587C18.1818 16.9587 17.4577 17.6828 17.4577 18.5628C17.4577 18.9387 17.146 19.2503 16.7702 19.2503ZM16.376 16.2712C16.5135 16.3903 16.651 16.5187 16.7702 16.6653C16.8893 16.5278 17.0177 16.3903 17.1643 16.2712C17.0268 16.152 16.8893 16.0237 16.7702 15.877C16.651 16.0237 16.5227 16.152 16.376 16.2712Z" fill="#7A28A0"/>
                                <path d="M6.1476 8.60159L7.55267 10.0722L10.5001 7.47511" stroke="#7A28A0" stroke-width="0.9"/>
                                <path d="M6.1476 13.6016L7.55267 15.0722L10.5001 12.4751" stroke="#7A28A0" stroke-width="0.9"/>
                            </svg>
                        </span>
                        <small>3단계</small>
                        <h3>결과 보기</h3>
                        <p>AI 또는 사람이 생성한 점수를 확인 합니다.</p>
                    </div>
                </div>
            </div>
            <!-- <div class="closeButton">
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                    Close
                </button>
            </div> -->
        </div>
      </div>
    </div>
</div>

<!-- The DisclaimerModal -->
<div class="modal aiContentModal" id="disclaimerModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-radius16">
        <div class="modal-body modalContent">
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M21.825 7.82463C22.2806 7.36902 22.2806 6.63033 21.825 6.17472C21.3694 5.7191 20.6307 5.7191 20.1751 6.17472L14 12.3498L7.825 6.17472C7.36939 5.7191 6.63069 5.7191 6.17508 6.17472C5.71947 6.63033 5.71947 7.36902 6.17508 7.82463L12.3501 13.9997L6.17508 20.1747C5.71947 20.6303 5.71947 21.369 6.17508 21.8246C6.63069 22.2802 7.36939 22.2802 7.825 21.8246L14 15.6496L20.1751 21.8246C20.6307 22.2802 21.3694 22.2802 21.825 21.8246C22.2806 21.369 22.2806 20.6303 21.825 20.1747L15.65 13.9997L21.825 7.82463Z" fill="#414E62"/>
                </svg>
            </button>
            <h4>면책 조항</h4>
            <p>
                AI 생성 콘텐츠 감지기는 AI 생성기에 의해 제작됐을 수도 있는 콘텐츠를 식별하는 데 도움이 되도록 설계됐습니다. 
                그러나 이 평가는 인간이 만든 콘텐츠와 AI가 만든 콘텐츠를 항상 정확하게 구분하지 못할 수 있으므로 콘텐츠의 
                성격을 결정하는 유일한 요소가 되면 안 됩니다. 콘텐츠를 면밀히 검토하고 개인적인 판단과 조직의 정책을 모두 
                고려해 최종 결정을 내려야 합니다.
            </p>
        </div>
      </div>
    </div>
</div>

<div class="brandLogo_sections">
    <div class="container">
        <div class="row">
            <div class="col-xl-2">
                <h2>글로벌 리더들의 신뢰</h2>
            </div>
            <div class="col-xl-10">
                <div class="cover_wrapper">
                    <div id="client-logos-enterprise" class="owl-carousel">
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="universities" width="180">
                            </div>
                        </div>

                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/StanfordUniversity.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/Caltech.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/MIT.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/Yale.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/Yonsei_University.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/client_logos/UniversityOfTokyo.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/oxford.png" alt="universities" width="180">
                            </div>
                        </div>
                        <div class="item">
                            <div class="client-inners">
                                <img src="../../../assets/images/cambridge.png" alt="universities" width="180">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<section class="section-md">
    <div class="container">
        <div class="row align-item-center">
            <div class="col-md-6">
                <div class="section-title">
                    <h3>기업용 AI 생성 콘텐츠 감지기 </h3>
                    <div class="HeadingSubLine"></div>
                    <p>
                        기업에서는 표준 콘텐츠 평가 이상의 정확도와 통찰력이 필요하다는 것을 잘 알고 이해하고 있습니다. 그렇기 때문에 트링카는
                        조직의 고유한 요구 사항을 충족하도록 맞춤화된 기본 기능 어드밴스 고급 솔루션인 AI 콘텐츠 감지기 기술의  
                        엔터프라이즈 버전을 제공합니다.
                    </p>
                    <p>
                        어드밴스 시스템은 콘텐츠에 대한 상세한 분석을 제공해 사람이 만든 요소와 AI가 생성한 요소를 조명하고 통찰력을
                        문장과 구문 수준까지 제공합니다.
                    </p>
                    <p>
                        기업용 트링카 AI 콘텐츠 감지 기능을 사용하면 모든 텍스트의 무결성을 최고 수준으로 검토할 수 있는 필수 기술을
                        갖추게 됩니다.
                    </p>
                    <p>트링카 AI 콘텐츠 감지기 기업에 어떤 이점을 제공할 수 있는지 자세히 알아보세요.</p>
                    <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">문의하기</button>
                </div>
            </div>
            <div class="col-md-6">
                <div class="sideImg">
                    <img src="../../../assets/images/AI-Generated-Content-Detector-for-Enterprises.svg" alt="parapharsing 1" alt="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-md bg-light-purple">
    <div class="container">
        <div class="row align-item-center flex-row-reverse">
            <div class="col-md-6">
                <div class="section-title">
                    <h3>트링카의 AI 콘텐츠 감지기를 선택해야 하는 이유</h3>
                    <div class="HeadingSubLine"></div>
                    <ul class="list-box">
                        <li>
                            <b>광범위한 LLM 모델 범위:</b> ChatGPT, GPT-4, Bard, Bing Chat, Claude와 같은 LLM에서 AI가 생성한 텍스트를 
                            감지합니다.
                        </li>
                        <li>
                            <b>신속하고 정확한 분석:</b> 높은 정확도로 즉각적인 결과를 받아보실 수 있습니다.
                        </li>
                        <li>
                            <b>패러프레이즈된 AI 콘텐츠 감지:</b> 의역된 경우에도 AI가 생성한 텍스트를 식별합니다.
                        </li>
                        <li>
                            <b>점수가 포함된 빠른 개요:</b> 텍스트에서 AI가 생성한 콘텐츠의 비율을 나타내는 점수를 확인할 수 있습니다.
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="sideImg">
                    <img src="../../../assets/images/why-choose-Trinka -AI-Content-Detector.svg" alt="parapharsing 2" alt="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-md bg-light-purple pt-0">
    <div class="container">
        <div class="row align-item-center">
            <div class="col-md-6">
                <div class="section-title">
                    <h3>트링카 AI 콘텐츠 감지기 전용 혜택 대상</h3>
                    <div class="HeadingSubLine"></div>
                    <ul class="list-box">
                        <li>
                            <b>작가 전용:</b> 구글과 같은 검색 엔진은 AI가 생성한 콘텐츠를 쉽게 감지하고 잠재적으로 순위에 불이익을 줄 수 있습니다.  콘텐츠가 독창적이고 사람이 작성한 것인지 확인하고 경쟁에서 한 발 앞서 나가보세요.
                        </li>
                        <li>
                            <b>교육용:</b> 사용자가 접하는 콘텐츠가 사람이 작성한 것인지 확인하고 교육가관 가이드라인에 부합하는지 확인해 보세요. 트링카 AI 감지기 툴은 진위 여부를 확인하는 데 필요한 명확성을 제공합니다. 
                        </li>
                        <li>
                            <b>출판사 전용:</b> 저자와 공동 저자의 작업을 확인하여 사람이 작성한 콘텐츠인지 식별합니다. 출판 전 콘텐츠의 독창성과 무결성을 보장할 수 있습니다. 
                        </li>
                        <li>
                            <b>연구자용:</b> 참고 자료와 학술 문서의 신뢰성과 진정성을 보장하여 연구 및 출판물의 무결성을 보호합니다.
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="sideImg">
                    <img src="../../../assets/images/benefit-from-trinka-AI-content.svg" alt="parapharsing 2" alt="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>Looking to Improve Overall Content Quality?</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="button-box">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">
                        <span>Try Now</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<div class="enterprise_contactUs">
    <p>전반적으로 콘텐츠 품질을 향상시켜 보세요.</p>
    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">
        <span>이용하기</span>
    </a>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>자주 묻는 질문</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            AI 콘텐츠 감지기(AI content detector)가 정확합니까? </a>
                                    </div>

                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                AI 콘텐츠 감지기는 AI 작성 텍스트 감지를 위해 설계된 전문 소프트웨어입니다. 이는 특정 텍스트가 ChatGPT와
                                                같은 AI 텍스트 생성 도구에 의해 작성된 것인지, 아니면 인간이 작성한 것인지 판단해 텍스트의 진위 여부를 
                                                명확히 보여줍니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">AI 감지기는 어떻게 작동하나요?
                                        </a>
                                    </div>

                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                AI 콘텐츠 감지기는 자연어 처리, 머신러닝, 딥러닝 기술을 활용해 텍스트를 분석합니다. 인간과 AI 글쓰기의 차이를
                                                알아내고, 텍스트 작성자를 예측하고, 인간 또는 AI 기원에 대한 가능성 점수를 할당하고, 업데이트된 학습 
                                                데이터를 통해 기능을 지속적으로 향상시킵니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">표절 감지와 AI 감지의 차이점은 정확합니까?</a>
                                    </div>

                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                표절 감지는 주로 다른 사람의 저작물, 아이디어 또는 콘텐츠를 적절한 출처 표시나 허가 없이 사용하는 표절 
                                                사례를 식별하는 데 중점을 둡니다. 이는 콘텐츠의 독창성을 유지하고 지적 재산권을 존중하는 것을 목표로 합니다.
                                                이와는 대조적으로, AI 작성 텍스트 감지는 특정 텍스트가 인간이 작성한 것인지 아니면 인공지능 시스템에 의해
                                                생성된 것인지를 구체적으로 판단합니다. 그 목표는 인간이 작성했든 AI가 생성했든 콘텐츠의 출처를 확인해 진위
                                                여부에 대한 통찰력을 제공하는 데 있습니다. 두 가지 유형의 감지는 모두 콘텐츠의 무결성 유지를 목표로 하지만,
                                                콘텐츠 평가와 독창성의 다른 측면을 다룹니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">교육자가 제출물에 ChatGPT와 같은 AI 도우미를 사용했는지 감지할 수 정확합니까?</a>
                                    </div>

                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                교육자는 AI의 학생 과제 개입을 감지할 수 있는 방법을 갖고 있습니다. 부자연스러운 언어, 불일치 또는 AI 감지 
                                                도구 외에도 불일치 또는 깊이 부족을 관찰할 수 있습니다. 학생은 학업적 부정직함으로 인식될 수 있는 학업 
                                                제출물을 AI에 의존하는 것을 피해야 합니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFive">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCFiveContent" aria-expanded="true"
                                            aria-controls="QuestionGCFiveContent">AI 감지 도구는 정확합니까?</a>
                                    </div>

                                    <div id="QuestionGCFiveContent" class="collapse"
                                        aria-labelledby="QuestionGCFive" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                AI 콘텐츠 감지기의 정확도는 다양할 수 있습니다. 예컨대 트링카 AI 콘텐츠 감지기는 ChatGPT, GPT-4, Bard 및 
                                                기타 주요 텍스트 생성 도구와 같은 출처에 대해 AI 생성 콘텐츠를 식별하는 데 높은 수준의 정밀도로 강력한 
                                                기능을 제공합니다. 기술이 계속 발전함에 따라 트링카  AI 콘텐츠 감지기는 정확성을 더 높여 온라인 정보의 
                                                신뢰성과 진실성을 보장하기 위해 노력하고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSix">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCSixContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixContent">Google은 AI 콘텐츠를 감지합니까?</a>
                                    </div>

                                    <div id="QuestionGCSixContent" class="collapse"
                                        aria-labelledby="QuestionGCSix" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                Google과 같은 검색 엔진은 AI가 생성한 콘텐츠를 감지하고 SEO에 미치는 영향에 대한 우려를 해소하기 위해 
                                                알고리즘 개선에 적극 노력하고 있습니다. AI가 생성한 콘텐츠로 품질이 낮은 스팸이 생성될 수 있다는 우려가 
                                                제기되고 있지만, 검색 엔진은 이런 콘텐츠를 효과적으로 식별하고 관리하는 데 적응하고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSeven">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCSevenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSevenContent">트링카는 인간이 작성한 텍스트가 AI 생성 텍스트로 수정된 혼합 텍스트를 감지할 수 정확합니까?</a>
                                    </div>

                                    <div id="QuestionGCSevenContent" class="collapse"
                                        aria-labelledby="QuestionGCSeven" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>물론입니다. 감지 보고서는 인간이 작성한 텍스트와 AI가 생성한 텍스트의 특정 섹션에 대한 통찰력을 제공합니다.
                                                여기에는 신뢰도 수준이 포함돼 있어 콘텐츠 출처를 투명하게 분석할 수 있습니다. 단 이 기능은  엔터프라이즈 버전 에서만 사용할 수 있습니다. 자세한 내용은 여기로 문의주세요: <a href="mailto:support@trinka.ai" class="link">support&#64;trinka.ai</a>
                                            </p>
                                                                                       
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCEight">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCEightContent" aria-expanded="true"
                                            aria-controls="QuestionGCEightContent">트링카 AI 콘텐츠 감지기는 무료입니까?</a>
                                    </div>

                                    <div id="QuestionGCEightContent" class="collapse"
                                        aria-labelledby="QuestionGCEight" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                트링카의 AI 콘텐츠 감지기는 특정 제한 사항과 함께 무료로 제공됩니다. 사용자는 하루에 최대 10회 세션을 
                                                이용할 수 있으며, 각 세션에서는 최대 500개의 단어를 분석할 수 있습니다. 이를 통해 무제한으로 콘텐츠를 
                                                검토할 수 있어 정확성과 진실성을 보장합니다. 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>